module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-switch",
    on: {
      "click": function($event) {
        _vm.changeLang()
      }
    }
  }, [_c('span', {
    staticClass: "current-lang"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n.locale) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5efd7168","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSwitch.vue
// module id = 116
// module chunks = 0